import {
    Component,
    OnInit,
    AfterViewInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service'

@Component({
    templateUrl: './AppViews/MultiLocationTask/multilocationtask.html'
})

export class multiLocationTaskComponent implements OnInit, AfterViewInit {

    constants: Constants;
    userDetail: any;
    filter: any = {
        'CustomerId': 0,
        'FromDate': "",
        'ToDate': "",
        'StatusId': "0"
    };
    projectFilterFlag: any;
    getMultiLocationTaskUrl: any;
    public showLoader = false;
    selfuser: boolean = true;
    multiLocationTaskItems: any = [];
    customerList: any = [];
    cityData: any = [];
    stateData: any = [];
    isAdd: boolean = true;
    editMultiLocationTaskData: any = {};
    addMultiLocationTaskData: any = {};
    editTaskLocationData: any = {};
    addTaskLocationData: any = {};
    isMultiLocationTaskFormSubmitted: boolean;
    isTaskLocationFormSubmitted: boolean;
    taskStatusItems: any = [];




    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.TeamId = "";
        this.projectFilterFlag = JSON.parse(localStorage.getItem('ProjectFilters'));
        this.getMultiLocationTaskUrl = "LocationTask/GetTaskForVendor"
    }

    ngOnInit() {
        this.GetParameterData();
        this.GetMultiLocationTaskList(true);
        console.log(this.userDetail);
    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

    }



    GetMultiLocationTaskList(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        } else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost(this.getMultiLocationTaskUrl, {
            "TaskId": 0,
            "CustomerId": this.filter.CustomerId,
            "FromDate": this.filter.FromDate,
            "ToDate": this.filter.ToDate,
            "StatusId": this.filter.StatusId,
            "LoggedInUser": UserId

        }).subscribe(
            data => {
                this.multiLocationTaskItems = data["LocationTaskList"];
            },
            err => {
                console.log("GetMultiLocationTaskList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                console.log(this.multiLocationTaskItems);
                this.showLoader = false;
            }
        );
    }
    GetParameterData() {
        this._httpService.ajaxPost('Customer/GetCustomer', {
            "CustomerId": 0,
            "CountryId": 0,
            "CustomerStatus": true
        }).subscribe(
            data => {
                this.customerList = data["CustomerList"];
                this.customerList.sort(function (a, b) {
                    if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase()) return -1;
                    if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase()) return 1;
                    return 0;
                })
            },
            err => {
                console.log("GetCustomerList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter', {
                    "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"]
                }).subscribe(
                    data => {
                        this.taskStatusItems = data["Parameter"];
                        this.taskStatusItems.sort(function (a, b) {
                            if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1;
                            if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1;
                            return 0;
                        })
                    },
                    err => {
                        console.log("GetParameter Failed with status: " + err.status);
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                        // console.log(this.taskStatusItems);
                    });

            }
        );

        // setTimeout(function () {
        //     $(".pop-comment").popover({
        //         //content: 'test'
        //         content: function () {
        //             return $(this).parent().find('p').html();
        //         }
        //     });
        // }, 500);
    }

    public clearFilter() {
        this.filter = {
            'CustomerId': 0,
            'FromDate': "",
            'ToDate': "",
            'StatusId': "0"
        };
    }

    private dateSorter(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.PlannedStartDate, 'DD/MM/YYYY');

        if (item.PlannedStartDate == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/MultiLocationTask/multilocationtask.component.ts
 **/